export interface Input {
  url: string;
  label: string;
  content: Marko.Body;
}

<a href=input.url title=input.label>
  <${input.content}/>
</a>
